import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http } from '@angular/http';

import { Globals } from './globals'
import { BondMathComponentService } from './bondmathComponent.service';
import { Subscription }   from 'rxjs/Subscription';

@Injectable()
export class BondMath {
    private _globals:Globals;
    
    constructor(private http: Http, private _srvc: BondMathComponentService) {
        this._globals = new Globals();
	}

    loadSetup(calcId: string) {
		console.log('bondmath : loadSetup : Start : ' + calcId);
        
        return new Promise((resolve, reject) => {
			resolve(true);
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/bondmath/bondmath.ts